// Mock data for BRN Barbearia

export const brand = {
  name: 'BRN',
  full: 'BRN Barbearia',
  tagline: 'BARBEARIA',
  logo: 'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/klsgownm_D82DDA66-2F6F-4D5E-9807-27867A2D4379.png',
  phone: '(11) 98398-9160',
  phoneRaw: '5511983989160',
  email: 'barbeariabrn@gmail.com',
  instagram: '_brnbarbearia',
  instagramUrl: 'https://instagram.com/_brnbarbearia',
  address: 'Rua Oswaldo Cruz, 250 — Ponte São João, Jundiaí - SP',
  city: 'Jundiaí',
};

export const whatsappLink = `https://api.whatsapp.com/send?phone=${brand.phoneRaw}&text=${encodeURIComponent(
  'Olá, acessei o site da BRN Barbearia e gostaria de agendar um horário.'
)}`;

export const heroImages = [
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/lzw6zjrh_IMG_0833.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/ckd6mvku_IMG_0834.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/u0jem6c7_IMG_0835.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/o19epm95_IMG_0836.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/th8fz4a0_IMG_0837.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/qj9fx9vj_IMG_0839.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/o7onyfsl_IMG_0792.jpeg',
];

export const features = [
  {
    title: 'Padrão BRN',
    description: 'estrutura organizada, atendimento padronizado e excelência em cada detalhe.',
  },
  {
    title: 'Identidade',
    description: 'mais que um corte: uma marca que valoriza disciplina e evolução constante.',
  },
  {
    title: 'Profissionais preparados',
    description: 'barbeiros que representam uma cultura forte, focada em entregar acima da média.',
  },
  {
    title: 'Experiência',
    description: 'cada visita transforma minutos de cuidado em confiança, respeito e presença.',
  },
];

export const units = [
  {
    name: 'Unidade Ponte São João',
    image: 'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/i4589k1k_B4487873-F305-4439-B618-330EE37E7C14.jpeg',
    address: 'Rua Oswaldo Cruz, 250 — Ponte São João, Jundiaí - SP',
  },
];

export const testimonials = [
  {
    name: 'Matheus M S',
    text: 'Ir à BRN Barbearia é mais do que um simples corte, é um momento de relaxamento e cuidado pessoal. Hoje fiz corte, barba, sobrancelha e barboterapia, saí renovado. Ambiente super tranquilo e agradável. Profissionalismo que transmite confiança e um atendimento que te faz sentir especial.',
  },
  {
    name: 'Lucas Pires',
    text: 'Excelente opção em Jundiaí! A BRN tem uma localização ótima, fácil de chegar, e o espaço é muito bem montado, limpo e moderno. Fiz corte e sobrancelha, o resultado ficou show. Ótima conversa e preço justo pela qualidade entregue. Super indico!',
  },
  {
    name: 'Michelle Marques',
    text: 'Passando pra parabenizar o trabalho, meu namorado passou na BRN e fiquei muito satisfeita com o resultado. O talento da equipe transforma não apenas aparências, mas também a confiança e a identidade de cada pessoa. Ficou impecável!',
  },
  {
    name: 'Eduarda Pires',
    text: 'Por indicação de uma amiga levei meu pai à BRN Barbearia, ele voltou outra pessoa, rejuvenesceu uns 10 anos, ficou super alegre com sua autoestima renovada e isso para mim não tem preço!! Parabéns ao time, muito sucesso!!',
  },
  {
    name: 'Rafael Andrade',
    text: 'Ambiente impecável, atendimento de altíssimo nível e barbeiros extremamente atenciosos. Saí com a sensação de ter recebido muito mais do que um corte. Recomendo de olhos fechados.',
  },
  {
    name: 'Bruno Carvalho',
    text: 'Já passei por várias barbearias na região, mas a BRN é outro patamar. Toda a experiência, do agendamento ao pós-atendimento, mostra que existe um padrão de verdade. Vale cada minuto.',
  },
];

export const galleryImages = [
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/urp649ek_IMG_0827.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/oruy7ntj_IMG_0831.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/5ytp1ff5_IMG_0832.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/b8nl2yb7_IMG_0794.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/j23kq0vk_IMG_0710.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/dfkzlb32_IMG_0715.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/n1ewfs5o_IMG_0716.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/vt75lvph_IMG_0726.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/yoi2fq46_IMG_0705.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/qsamhc44_IMG_0706.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/xk43e35v_IMG_0707.jpeg',
  'https://customer-assets.emergentagent.com/job_sharp-cuts-67/artifacts/txetk6ap_IMG_0836_Original.jpeg',
];

export const navServices = [
  'Corte',
  'Barba',
  'Corte + Barba',
  'Sobrancelha',
  'Barboterapia',
];
